import {Observable, Subscription} from 'rxjs';

import ISolutionState from '../../../../Solutions/Shared/Interfaces/ISolutionState';
import IPlaybackStore from '../Interfaces/IPlaybackStore';

const subscribeToTimeUpdate = (
    timeUpdate$: Observable<ISolutionState>,
    playbackStore: IPlaybackStore
): Subscription =>
    timeUpdate$
        .subscribe((state) => playbackStore.actions.updateTime({
            currentTime: state.currentTime,
            minTime: state.minTime,
            maxTime: state.maxTime
        }));

export default subscribeToTimeUpdate;